module.exports = __webpack_public_path__ + "static/media/18ECA31.9182264e.jpg";